import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import barReviewApi from "api/barReviewApi";

export const getBarReviews = createAsyncThunk(
  "BarReview",
  async (params: any = {}) => {
    try {
      const response = await barReviewApi.getBarReviews(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getBarReviewList = async (params: any = {}) => {
  try {
    const response = await barReviewApi.getBarReviews(params);
    return response;
  } catch (error) {
    return error;
  }
};

export const getBarReviewDetail = async (
  id: string | number,
  params: any = {}
) => {
  try {
    const response = await barReviewApi.getBarReviewDetail(id, params);
    return response;
  } catch (error) {
    return error;
  }
};

export const postBarReview = async (data: any = {}) => {
  try {
    const response = await barReviewApi.postBarReview(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putBarReview = async (id: string | number, data: any = {}) => {
  try {
    const response = await barReviewApi.putBarReview(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
